import {REPORT_COACHES_ABOVE_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_COACHES_ABOVE_RANK,
};
